import React from 'react'
import AddAlbumsToAreaContainer from '../../modules/AreaManagement/containers/AddAlbumsToAreaContainer/AddAlbumsToAreaContainer'

const AddAlbumsToArea = () => {
  return (
    <AddAlbumsToAreaContainer />
  )
}

export default AddAlbumsToArea